import React from "react";
import Dashboard from "../Dashboard/Dashboard";
import MasterMailLogsSection from "../../Sections/MasterTenantLogs";

const MasterMailLogsComponent = () => {
    return (
        <Dashboard sectionName={<MasterMailLogsSection />} />
    );
};

export default MasterMailLogsComponent;
